import './App.css';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import Home from './Pages/Home';

// Các trang phụ được tách thành chunk riêng, chỉ tải khi người dùng truy cập
const CallCenter = lazy(() => import('./Dangkykhamchuabenh/Tongdai/CallCenter'));
const BookAppointment = lazy(() => import('./Dangkykhamchuabenh/dichvukcb/BookAppointment'));
const ExpertConsultation = lazy(() => import('./Dangkykhamchuabenh/Hopdapcungchuyengia/ExpertConsultation'));
const CheckResults = lazy(() => import('./Dangkykhamchuabenh/Tracuuketquakcb/CheckResults'));
const Organization = lazy(() => import('./Sections/Organization/Organization'));
const NewsEventsPage = lazy(() => import('./modules/tintuc/pages/NewsEventsPage'));
const ArticleDetailPage = lazy(() => import('./modules/tintuc/pages/ArticleDetailPage'));
const PartyPoliticsPage = lazy(() => import('./modules/partypolitics/pages/NewsEventsPage'));
const PartyArticleDetailPage = lazy(() => import('./modules/partypolitics/pages/ArticleDetailPage'));
const HoptacNewsEventsPage = lazy(() => import('./modules/Hoptac/pages/NewsEventsPage'));
const HoptacArticleDetailPage = lazy(() => import('./modules/Hoptac/pages/ArticleDetailPage'));
const Khamchuabenh = lazy(() => import('./Khamchuabenh/Khamchuabenh'));
const Thutucxuatvien = lazy(() => import('./Khamchuabenh/Thutucxuatvien'));
const Quytrinhthanhtoan = lazy(() => import('./Khamchuabenh/Quytrinhthanhtoan'));
const CustomerGuidePage = lazy(() => import('./Khachhang/CustomerGuide'));
const Danhgia = lazy(() => import('./Khachhang/Danhgia'));
const Donvi = lazy(() => import('./Thongtinchung/Donvi/Donvi'));
const GioithieuBV = lazy(() => import('./Thongtinchung/GioithieuBV/GioithieuBV'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/organization" element={<Organization />} />
          <Route path="/news-events" element={<NewsEventsPage />} />
          <Route path="/news-events/:slug" element={<ArticleDetailPage />} />
          <Route path="/party-politics" element={<PartyPoliticsPage />} />
          <Route path="/party-politics/:slug" element={<PartyArticleDetailPage />} />
          <Route path="/duoc-pham-suc-khoe" element={<HoptacNewsEventsPage />} />
          <Route path="/duoc-pham-suc-khoe/:slug" element={<HoptacArticleDetailPage />} />
          <Route path="/kham-chua-benh" element={<Khamchuabenh />} />
          <Route path="/kham-chua-benh/loai-hinh" element={<Thutucxuatvien />} />
          <Route path="/kham-chua-benh/thanh-toan" element={<Quytrinhthanhtoan />} />
          <Route path="/thong-tin-chung/thong-tin-benh-vien" element={<GioithieuBV />} />
          <Route path="/thong-tin-chung/cac-don-vi" element={<Donvi />} />
          <Route path="/customer-guide" element={<CustomerGuidePage />} />
          <Route path="/danh-gia" element={<Danhgia />} />
          <Route path="/call-center" element={<CallCenter />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/expert-consultation" element={<ExpertConsultation />} />
          <Route path="/check-results" element={<CheckResults />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
